import { createElement } from "react";
import { Page } from "../components/Page.fs.js";
import { Row } from "../../../Components/UtilComponents.fs.js";
import { cursorPointer, Padding, Gap } from "../../../Styles/Utils.fs.js";
import { singleton, ofArray } from "../fable_modules/fable-library.3.7.17/List.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.1.2.6/./Mui.fs.js";
import Card from "@material-ui/core/Card";
import { join } from "../fable_modules/fable-library.3.7.17/String.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.3.10.0/./Router.fs.js";
import { Page$2__toUrl_2B594 } from "../../../BidirectionalRouting/BidirectionalRouting.fs.js";
import { epcCreate, dossierCreate } from "../AppRoutes.fs.js";
import CardContent from "@material-ui/core/CardContent";
import { Interop_reactApi } from "../fable_modules/Feliz.1.68.0/./Interop.fs.js";
import Paper from "@material-ui/core/Paper";

export function StartNew(startNewInputProps) {
    let children_2, elems_1, children, elems_3, children_1;
    const currentPage = startNewInputProps.currentPage;
    return createElement(Page, {
        currentPage: currentPage,
        title: "Kies een type",
        actions: [],
        children: [(children_2 = singleton(createElement(Row, {
            classes: ofArray([Gap.L, Padding.L]),
            children: ofArray([MuiHelpers_createElement(Card, [["className", join(" ", [cursorPointer])], ["onClick", (_arg) => {
                RouterModule_nav(ofArray(Page$2__toUrl_2B594(dossierCreate)), 1, 1);
            }], (elems_1 = [(children = ofArray([createElement("h2", {
                children: ["Asbestattest"],
            }), createElement("p", {
                children: ["Start een nieuw asbestattest-dossier (AIA)."],
            })]), MuiHelpers_createElement(CardContent, [["children", Interop_reactApi.Children.toArray(Array.from(children))]]))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]), MuiHelpers_createElement(Card, [["className", join(" ", [cursorPointer])], ["onClick", (_arg_1) => {
                RouterModule_nav(ofArray(Page$2__toUrl_2B594(epcCreate)), 1, 1);
            }], (elems_3 = [(children_1 = ofArray([createElement("h2", {
                children: ["EPC"],
            }), createElement("p", {
                children: ["Start een nieuw EPC-dossier (energieprestatiecertificaat)."],
            })]), MuiHelpers_createElement(CardContent, [["children", Interop_reactApi.Children.toArray(Array.from(children_1))]]))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])]),
        })), MuiHelpers_createElement(Paper, [["children", Interop_reactApi.Children.toArray(Array.from(children_2))]]))],
    });
}

